import tzData from '@/data/timezones.json';

export type TimezoneFeature = {
  zone: number;
  geometry:
    | { type: 'Polygon'; coordinates: number[][][] }
    | { type: 'MultiPolygon'; coordinates: number[][][][] };
};

export const TIMEZONES = (tzData as { zones: TimezoneFeature[] }).zones;

export function polygonsOf(feature: TimezoneFeature): number[][][][] {
  return feature.geometry.type === 'Polygon'
    ? [feature.geometry.coordinates]
    : feature.geometry.coordinates;
}
